function Footer() {
  return (
    <>
      <div className="contact">Send Me Email: <a style={{textDecoration: "none"}} href="mailto: niloo.ast@gmail.com">niloo.ast@gmail.com</a></div>
    </>
  );
}

export default Footer;
